module.exports = __webpack_public_path__ + "static/media/DecretoCredencialPakHokPai  Maestro Tak50 dpia.df4c8c1f.jpg";